import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
import "text-security/text-security.css";
import configureStore, { history } from './appRedux/store';
import App from "./containers/App/index";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const store = configureStore(/ provide initial state if any /);
const NextApp = () => (
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </ConnectedRouter>
    </I18nextProvider>
  </Provider>
);

export default NextApp;
